import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import PasswordIndicator from '@components/passwordStrengthChecker/passwordIndicator'

import {
  Container, CheckArea, Text, Title, Content
} from './styles'

const PasswordMustHave = ({ password }) => {
  const [hasUppercase, setHasUppercase] = useState(false)
  const [hasNumber, setHasNumber] = useState(false)
  const [hasSpecialChar, setHasSpecialChar] = useState(false)
  const [hasMinLength, setHasMinLength] = useState(false)

  const hasUppercaseLetter = (str) => /[A-Z]/.test(str)
  const hasNumberCharacter = (str) => /\d/.test(str)
  const hasSpecialCharacter = (str) => /[\W_]/.test(str)
  const hasMinimumLength = (str) => str.length >= 8

  useEffect(() => {
    setHasUppercase(hasUppercaseLetter(password))
    setHasNumber(hasNumberCharacter(password))
    setHasSpecialChar(hasSpecialCharacter(password))
    setHasMinLength(hasMinimumLength(password))
  }, [password])

  return (
    <Container>
      <Title>A senha precisa conter: </Title>
      <Content>
        <CheckArea>
          <PasswordIndicator check={hasUppercase} />
          <Text>Uma letra maiúscula</Text>
        </CheckArea>
        <CheckArea>
          <PasswordIndicator check={hasNumber} />
          <Text>Um número</Text>
        </CheckArea>
        <CheckArea>
          <PasswordIndicator check={hasSpecialChar} />
          <Text>Um caractere especial</Text>
        </CheckArea>
        <CheckArea>
          <PasswordIndicator check={hasMinLength} />
          <Text>Pelo menos 8 caracteres</Text>
        </CheckArea>
      </Content>
    </Container>
  )
}

PasswordMustHave.propTypes = {
  password: PropTypes.string.isRequired,
}

export default PasswordMustHave
